import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { tos, tosName, tosPath } from '../licensing/tos';
import { ConfirmationBaseModal } from '../modals/confirmation-modal';
import { UserService } from '../user/user.service';
import { ModalLicensingArgs } from './modal-licensing-args';

@Component({
    selector: 'licensing',
    templateUrl: './licensing.component.html',
    styleUrls: ['./licensing.component.scss']
})
export class LicensingModal extends ConfirmationBaseModal<ModalLicensingArgs, boolean> {
    okText: string = 'Agree';
    preview: boolean = false;
    downloadPath: string = null;
    args: ModalLicensingArgs;
    private subject: Subject<boolean>;
    constructor(private UserService: UserService) {
        super();
        this.args = new ModalLicensingArgs(tos, 'TOS', tosPath, tosName);
    }

    onActivate(args: ModalLicensingArgs) {
        this.subject = new Subject<boolean>();
        this.args = args;
        this.downloadPath = args.DocumentPath;
        return this.subject;
    }

    onOkEvent(e: MouseEvent) {
        this.subject.next(true);
        this.subject.complete();

    }

    isDataValid() {
        return true;
    }

    onClose() { }

    showDialog(args: ModalLicensingArgs): Observable<boolean> {
        let result = this.onActivate(args);
        this.initialize();
        return result;
    }

    onCancelEvent(e: MouseEvent) {
        /* don't bother to send on next again, we will log out the user
        just close the subject*/
        e.preventDefault();
        this.closeDialog();
        this.subject.next(false);
        this.subject.complete();
        this.UserService.logOut();
    }

}



// WEBPACK FOOTER //
// ./src/app/licensing/licensing-modal.component.ts